import { Icon, Icons } from '@silverfort/sf-components';
import { ReportType } from '../../ServiceAccountsTypes';
import { SERVICE_ACCOUNT_EXPORT_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';

export const ReportManagerMessages = ({
    managerMessages,
    removeMessage
}: {
    managerMessages: { key: ReportType; isJson: boolean; isLoading: boolean; id: number }[];
    removeMessage: (id: number) => void;
}) => {
    return (
        <div className="w-full">
            {managerMessages.map((message, index) => {
                return !message.isLoading ? (
                    <div key={message.id} className="h-10 w-full px-4 bg-sf-light-100 border border-sf-gray-100">
                        <div className="h-full flex justify-between items-center">
                            <div className="flex gap-2">
                                <Icon icon={Icons.CircleCheck} />
                                <div className="text-xs font-medium font-sf">
                                    {`Successfully generated ${SERVICE_ACCOUNT_EXPORT_OPTIONS[
                                        message.key
                                    ].reportName.toLowerCase()}
                                        (${message.isJson ? 'JSON' : 'CSV'})`}
                                </div>
                            </div>
                            <button onClick={() => removeMessage(message.id)} className="text-xs font-sf">
                                close
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="h-10 w-full px-4 bg-sf-light-100 border border-sf-gray-100 text-xs">
                        <div className="h-full flex items-center gap-2">
                            <Icon className="animate-spin" icon={Icons.Loader} />
                            <div className="font-medium">{`Generating ${SERVICE_ACCOUNT_EXPORT_OPTIONS[
                                message.key
                            ].reportName.toLowerCase()} (${message.isJson ? 'JSON' : 'CSV'})`}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
